<app-loading class="m-5" *ngIf="loading"></app-loading>

<div id="hojanormal" *ngIf="(registros > 0)" class="col-lg-12">
  <div class="doNotPrint" style="text-align: left" class="col-lg-12">
    <br>
    <h2>
        <b> <i> &nbsp; ORDEN DE PAGO NRO: 000{{ codpag }} </i> </b>
        <button mat-icon-button color="danger" (click)="ocultarTruco(); print2();">
          <mat-icon aria-label="print">print</mat-icon>
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <img (click)="contar()" src="../../../../assets/img/newass.png" style="width: 210px; height: 90px; text-align: right;">
        <input name="opagotruco" [(ngModel)]="opagotruco" id="opagotruco" *ngIf="PAGUIN==true" type="text">    
        <button *ngIf="PAGUIN==true" (click)="cargaGridTruco()">UP</button>
        <button id="botontruco" *ngIf="PAGUIN==true" (click)="ocultarTruco()">X</button>
    </h2> 
    <br>
    <hr>
  </div>
  <div id="print-section" class="col-lg-12">
    <h4 style="text-align:center"><b> TIPO DE PAGO: </b> {{ moti }},<b>&nbsp;DESCRIPCION: </b> <i>"{{ detpa }}"</i></h4>
    <hr>
    <h5>&nbsp;&nbsp;Seccional / Delegación: {{ secc }} </h5>
    <h5>&nbsp;&nbsp;Fecha Pago: {{ feccarga | date:"dd/MM/yyyy" }} </h5>
    <hr>
    <h5>&nbsp;Detalle del Pago</h5>
    <div style="width: 600px">
      <hr>
    </div>
    <div id="grid" #TABLE>
      <div class="example-container mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="ID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> NRO-OP </th>
              <td mat-cell *matCellDef="let element"> {{element.ID}} </td>
          </ng-container>
          <ng-container matColumnDef="CODGASTO">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CODGASTO </th>
              <td mat-cell *matCellDef="let element"> {{element.CODGASTO}} </td>
          </ng-container>
          <ng-container matColumnDef="FECHAPAGO">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHAPAGO </th>
              <td mat-cell *matCellDef="let element"> {{element.FECHAPAGO | date:"dd/MM/yy"}} </td>
          </ng-container>
          <ng-container matColumnDef="OBSERVACIONES">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
              <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element">"{{(element.OBSERVACIONES !=='null') ? (element.OBSERVACIONES) : ('----')}}"</td>
          </ng-container>
          <ng-container matColumnDef="IMPORTE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> IMPORTE </th>
              <td style="font-weight: bold;" mat-cell *matCellDef="let element"> {{element.IMPORTE | currency:"$"}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row (click)="selectRow(row.ID)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
        </table>
      </div>    
      <mat-paginator hidden [pageSize]=500 [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
    <br>
    <!--2DA TABLA-->
    <h5>Detalle de Fondos</h5>
    <div id="fotocopia">
      <table class="table table-condensed">
        <thead>
          <tr>
            <td ><strong>CUENTA</strong></td>
            <td ><strong>CONCEPTO</strong></td>
            <td ><strong>NRO. OPERAC.</strong></td>
            <td ><strong>FECHA-VTO.</strong></td>
            <td ><strong>HABER</strong></td>
          </tr>
          <tr>
            <td ><strong>{{ cuentaBanco }} </strong></td>
            <td ><strong>{{ descCuentaBanco }}</strong></td>
            <td ><strong>{{ nroOpera }}</strong></td>
            <td ><strong>{{ feccarga | date:"dd/MM/yy" }}</strong></td>
            <td ><strong>SUBTOTAL: {{ sumatoria | currency:"$"}}</strong></td>
          </tr>
          <tr *ngIf="TIENEFONDOS">
            <td ><strong>---</strong></td>
            <td ><strong>DINERO A CUENTA</strong></td>
            <td ><strong>---</strong></td>
            <td ><strong>---</strong></td>
            <td ><strong>FONDO: (-){{ FONDOS | currency:"$"}}</strong></td>
          </tr>
        </thead>
        </table> 
    </div>
    <br>
    <div style="width: 100%; text-align:center;">
      <br>
      <hr>
      <h5 *ngIf="!TIENEFONDOS" style="background-color: rgb(165, 165, 159); "><b>TOTAL PAGADO:</b> {{ sumatoria | currency:"$" }} </h5>
      <h5 *ngIf="TIENEFONDOS" style="background-color: rgb(165, 165, 159); "><b>TOTAL PAGADO:</b> {{ sumatoria - FONDOS | currency:"$" }} </h5>
    </div>
  </div>
  <div class="doNotPrint">
  </div>
</div>